
import { subDays, addDays, format } from "date-fns";

/**
 * Calculate the start date based on selected time range
 */
export const getStartDate = (timeRange: "7days" | "30days" | "90days") => {
  const today = new Date();
  switch (timeRange) {
    case "7days":
      return subDays(today, 7);
    case "30days":
      return subDays(today, 30);
    case "90days":
      return subDays(today, 90);
    default:
      return subDays(today, 30);
  }
};

/**
 * Calculate days remaining based on current stock and usage rate
 */
export const calculateDaysRemaining = (currentStock: number, usageRate: number) => {
  return Math.floor(currentStock / usageRate);
};

/**
 * Predict restock date based on days remaining
 */
export const predictRestockDate = (daysRemaining: number) => {
  return addDays(new Date(), daysRemaining);
};

/**
 * Format a date for display in charts
 */
export const formatDateForChart = (date: Date) => {
  return format(date, "MMM d");
};

/**
 * Get ISO date string (YYYY-MM-DD)
 */
export const getISODate = (date: Date) => {
  return format(date, "yyyy-MM-dd");
};
